import client from '@/client/n8nClient';

export default class N8nService {
  static postListMonkWebhook(email) {
    return client
      .post('/webhook/57aa8276-9433-41a5-b4bf-71a95bdafce9', {email});
  }
}
